module.exports = __webpack_public_path__ + "static/media/etisalat-ic.f5a1754a.svg";